<div class="close-accout-wrapper">
  <p class="hand-icon">🤚</p>
  <p class="close-accout-qn">{{'close-account.close' | translate}}</p>
  <ion-button class="close-accout-btn" (click)="closeAccount()">{{'close-account.Yes' | translate}}</ion-button>
  <p class="keep-my-account" (click)="cancel()">{{'close-account.No' | translate}}</p>
</div>